import { SubscriptionProduct } from './../../models/subscription-product';
import { Product } from './../../models/product';

import { Injectable, OnInit } from '@angular/core';
import { DataService } from '../data-services/data.service';
import { Observable, of } from 'rxjs';
import { Price } from './../../models/price';

@Injectable({
  providedIn: 'root',
})
export class ProductService extends DataService<Product> implements OnInit {
  deactivate(
    productId: string,
    product: Product,
    organizationId: string
  ): Observable<Product> {
    const url = `${this.urlService.buildUrl(
      this.collectionname
    )}${organizationId}/deactivate/${productId}`;

    return this.http.patch<Product>(`${url}`, product);
  }

  getPlans(planname: string): Observable<SubscriptionProduct[]> {
    const url = `${this.urlService.buildUrl(
      this.collectionname
    )}/plans/${planname}`;

    return this.http.get<SubscriptionProduct[]>(`${url}`);
  }
  getPrices(productId: string): Observable<Price[]> {
    const url = `${this.urlService.buildUrl(
      this.collectionname
    )}/${productId}/price-list`;

    return this.http.get<Price[]>(`${url}`);
  }

  insertPrice(price: Price): Observable<Price> {
    const url = `${this.urlService.buildUrl(
      this.collectionname
    )}//insert-price`;

    return this.http.post<Price>(`${url}`, price);
  }

  deletePrice(productId: string, price: Price): Observable<Price> {
    const url = `${this.urlService.buildUrl(
      this.collectionname,
      productId
    )}/delete-price`;

    return this.http.patch<Price>(`${url}`, price);
  }

  protected collectionname = 'products';

  ngOnInit(): void {
    this.setCollectionName('products');
  }

  updatePrice(id: string, price: Price): Observable<Price> {
    // create price micro service
    const url = `${this.urlService.buildUrl(
      this.collectionname,
      id
    )}//update-price`;

    return this.http.patch<Price>(`${url}`, price);
  }

  getProduct(
    organizationId: string,
    productId: string
  ): Observable<SubscriptionProduct[]> {
    const url = `${this.urlService.buildUrl(
      this.collectionname
    )}${organizationId}/product/${productId}`;

    return this.http.get<SubscriptionProduct[]>(`${url}`);
  }
}
